import { apiBaseURL } from '../ProjectConstants';

/*
 =-=-=-=-=- data structure -=-=-=-=-=
 data = {
   'operationsBudget': [
        {
            'task : {
                'id': num
            },
            'projectedHours': num,
        }
    ],
    'researchBudget': [
        {
            'task': {
                'id': num
            },
            'ProjectedHours': num,
        }
    ],
    'materialsBudget': [
        {
            'materialName': string,
            'cost': num,
        }
    ],
      'billingCode': string,
}
*/
async function handlePutBudget(fetch, operations, research, materials, billingCode) {
    const body = {
        operationsBudget: operations.map((hour) => ({
            task: { id: hour.id },
            projectedHours: hour.projectedHours,
        })),
        researchBudget: research.map((hour) => ({
            task: { id: hour.id },
            projectedHours: hour.projectedHours,
        })),
        materialsBudget: materials.map(material => ({
            materialName: material.name,
            cost: material.cost,
        })),
        billingCode: billingCode,
    };

    const response = await fetch.put(`${apiBaseURL}/api/budget?billingCode=${billingCode}`, body);
    const isDataGood = response?.success && response?.data?.statusCode && response?.success !== 'Invalid Model';
    //const response = 'hi';
    //const isDataGood = true;
    console.log('handlePutBudgetbody', body);
    console.log('handlePutBudget response', response); 

    return {
        response,
        isDataGood
    };
}
export default handlePutBudget;